import { axios } from '@carvana/purchase-utils';

export const fetchInsuranceReferral = () =>
  axios({
    method: 'get',
    url: `${process.env.API_URL}/api/v1/insurance/referral`
  }).then(res => res.data);

export const fetchInsuranceReferralUrl = referralId =>
  axios({
    method: 'get',
    url: `${process.env.API_URL}/api/v1/insurance/referral/${referralId}/url`
  }).then(res => res.data);

export const uploadDocument = document =>
  axios({
    method: 'post',
    url: `${process.env.API_URL}/api/v1/insurance/customerrequest/document/upload`,
    data: document,
    headers: { 'Content-Type': 'multipart/form-data', accept: '*/*' }
  }).then(res => res.data);

export const fetchInsuranceConsent = () =>
  axios({
    method: 'get',
    url: `${process.env.INSURANCE_PURCHASE_MANAGER_API_URL}/api/v1/consent`
  }).then(res => res.data);

export const fetchInsuranceProfile = () =>
  axios({
    method: 'get',
    url: `${process.env.INSURANCE_PURCHASE_MANAGER_API_URL}/api/v1/embeddedprofile`
  }).then(res => res.data);

export const getInsuranceRootQuote = () =>
  axios({
    method: 'post',
    url: `${process.env.INSURANCE_PURCHASE_MANAGER_API_URL}/api/v1/quotes`,
    data: {
      successUrl: `${process.env.BASE_URL}/purchase`,
      cancelUrl: `${process.env.BASE_URL}/purchase`
    }
  }).then(res => res.data);

export const getProgressiveRC1Quote = () =>
  axios
    .get(
      `${process.env.INSURANCE_PURCHASE_MANAGER_API_URL}/api/v1/quotes/progressive`
    )
    .then(res => res.data);

export const getPolicyStatus = () =>
  axios
    .get(
      `${process.env.INSURANCE_PURCHASE_MANAGER_API_URL}/api/v1/policy/status`
    )
    .then(res => res.data);

export const validateProofOfInsurance = ({ formData }) =>
  axios
    .post(
      `${process.env.CUSTOMER_VERIFICATIONS_API_URL}/api/v1/proofofinsurance/validate`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    )
    .then(res => res.data);
